import axios from 'axios';
import {t} from 'i18next';
import {ISelectItem} from '../../../shared/types';
import {BackendErrorData} from '../../../utils/custom-errors/parseApiError';

export enum TranscriptSortKey {
  ModifiedNewest = 'modified-newest',
  ModifiedOldest = 'modified-oldest',
  CreatedNewest = 'created-newest',
  CreatedOldest = 'created-oldest',
}

export type SortConfig = {
  column: TranscriptSortColumn;
  direction: TranscriptSortDirection;
};

export enum TranscriptSortColumn {
  LastUpdatedOn = 'LastUpdatedOn',
  CreatedOn = 'CreatedOn',
}

export enum TranscriptSortDirection {
  DESC = 'DESC',
  ASC = 'ASC',
}
export enum MyTranscriptListMenuKey {
  Remove = 'remove',
  Edit = 'edit',
}

export enum MyTranscriptCreateKey {
  Create = 'create',
}

export enum IndicesDetailDocType {
  Included = 'included',
  Excluded = 'excluded',
}

export interface TranscriptFormValues {
  name: string;
  description: string;
  index: ISelectItem | null;
}
export interface TranscriptItemDataType {
  transcriptId: number;
  indexName: string;
  indexID: number;
  isActiveIndex: boolean;
  indexDocumentCount?: number;
  transcriptName: string;
  description: string;
  createdDate: string;
  updatedDate?: string;
  ownerName: string;
  isMyTranscript: boolean;
  isNew?: boolean;
  formattedCreatedDate?: string;
}

/**
 * Gets the localized label for a transcript sort key
 * @param sortKey - The sort key to get the label for
 * @returns The localized label string
 */
export const getTranscriptSortLabel = (sortKey: string): string => {
  const sortLabels: Record<TranscriptSortKey, string> = {
    [TranscriptSortKey.ModifiedNewest]: t(
      'ai.investigate.transcriptPanel.sortOptions.modifiedNewest'
    ),
    [TranscriptSortKey.ModifiedOldest]: t(
      'ai.investigate.transcriptPanel.sortOptions.modifiedOldest'
    ),
    [TranscriptSortKey.CreatedNewest]: t(
      'ai.investigate.transcriptPanel.sortOptions.createdNewest'
    ),
    [TranscriptSortKey.CreatedOldest]: t(
      'ai.investigate.transcriptPanel.sortOptions.createdOldest'
    ),
  };
  return (
    sortLabels[sortKey as TranscriptSortKey] ||
    sortLabels[TranscriptSortKey.ModifiedNewest]
  );
};

export const getMyTranscriptMenuLabel = (menuKey: string): string => {
  const menuLabels: Record<MyTranscriptListMenuKey, string> = {
    [MyTranscriptListMenuKey.Remove]: t('ai.investigate.listItem.menu.optionA'),
    [MyTranscriptListMenuKey.Edit]: t('ai.investigate.listItem.menu.optionB'),
  };
  return (
    menuLabels[menuKey as MyTranscriptListMenuKey] ||
    menuLabels[MyTranscriptListMenuKey.Remove]
  );
};

export interface SortableTranscriptItem {
  transcriptId: number;
  transcriptName: string;
  createdDate: string;
  date?: string;
}

export const enum TranscriptPanelType {
  MyTranscripts = 'MyTranscripts',
  TeamTranscripts = 'TeamTranscripts',
}

export const isDuplicateTranscriptNameError = (error: unknown): boolean => {
  if (!axios.isAxiosError<BackendErrorData>(error)) {
    return false;
  }

  const data = error.response?.data;

  return data?.status === 409 && data?.title === 'Conflict.';
};